<template>
  <div class="metrics-empty-state">
    <div class="paragraph-m">
      {{ title || $t("metrics.noDataAvailable") }}
    </div>
    <div class="paragraph-s">
      {{ description || $t("metrics.noDataAvailableDescription") }}
    </div>
  </div>
</template>

<script>
export default {
  name: "MetricsEmptyState",

  props: {
    title: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.metrics-empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 200px;
  width: 256px;
  margin: 0 auto;
  text-align: center;

  .paragraph-m {
    color: var(--color-text-neutral-on-white);
  }

  .paragraph-s {
    color: var(--color-text-neutral-secondary, #566370);
  }
}
</style>
